import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "6", cy: "6", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "6", cy: "18", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "20", x2: "8.12", y1: "4", y2: "15.88", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "14.47", x2: "20", y1: "14.48", y2: "20", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "8.12", x2: "12", y1: "8.12", y2: "12", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Scissors";
const Scissors = memo(themed(Icon));
export {
  Scissors
};
//# sourceMappingURL=scissors.js.map
